import React from 'react';

function QuestionCard(props) {
    const {
        questionType,
        questionIndex,
        handleDelete,
        questionData,
        updateQuestionData,
        copyQuestionData,
        questionList,
        moveQuestion,
        postQuestion,
        module,
        questionListLength
    } = props;

    let checkQuestion = { id: '', question: '', option: [], is_required: false, long_answer: false };

    let defaultQuestionError = {
        questionError: '',
        optionError: '',
    };

    const [isEdit, setEdit] = React.useState(false);
    const [question, setquestion] = React.useState();
    const [questionChoiceData, setChoiceQuestionData] = React.useState(checkQuestion);
    const [flag, setFlag] = React.useState(false);
    const [allQuestionList, setQuestionList] = React.useState([]);
    const [showBranch, setShowBranch] = React.useState(false);
    const [indexData, setIndexData] = React.useState();
    const [options, setOptions] = React.useState([]);
    const [questionError, setQuestionError] = React.useState(defaultQuestionError);

    React.useEffect(() => {
        if (questionType !== undefined) {
            setquestion(questionType.toString());
            setIndexData(questionIndex);
        }
    }, [questionType]);

    React.useEffect(() => {
        setQuestionList(questionList);
    }, [questionList]);

    React.useEffect(() => {
        if (questionData !== undefined) {
            if (questionType === 1 || questionType === 2) {
                let data = questionData;
                let optionArr = [];
                for (let i = 0; i < questionData.option.length; i++) {
                    let option = {
                        options: questionData.option[i].options,
                        branch_question_id: questionData.option[i].branch_question_id,
                    };
                    optionArr.push(option);
                }
                data['option'] = optionArr;
                setOptions(optionArr);

                setChoiceQuestionData(data);
            } else {
                setChoiceQuestionData(questionData);
            }
        }
    }, [questionData]);

    const updateData = () => {
        if (validateQuestion()) {
           

            let data = {
                ...questionChoiceData,
                questiontype_id: question,
            };
            updateQuestionData(data, questionIndex);
            setEdit(false);
        }
    };

    const cancelBranching = () => {
        let arr = [];
        options.forEach((option) => {
            arr.push({ options: option.options, branch_question_id: '' });
        });
        setOptions(arr);
        setFlag(!flag);
    };

    const handleChoiceQuestionData = (e, index) => {
        setQuestionError(defaultQuestionError);
        if (e.target.name === 'option') {
            let arr = options;
            let optionData = arr[index];
            optionData['options'] = e.target.value;
            arr[index] = optionData;
            setOptions(arr);
            setFlag(!flag);
            setChoiceQuestionData((checkQuestion) => ({ ...checkQuestion, ['option']: arr }));
        } else {
            setChoiceQuestionData((checkQuestion) => ({ ...checkQuestion, [e.target.name]: e.target.value }));
        }
    };

    const addOption = (type) => {
        if (type === 'other') {
            setOptions((options) => [...options, { options: 'Others', branch_question_id: '' }]);
            let arr = options;
            arr.push({ options: 'Others', branch_question_id: '' });
            setOptions(arr);
            setFlag(!flag);
            setChoiceQuestionData((checkQuestion) => ({ ...checkQuestion, ['option']: arr }));
        } else {
            setOptions((options) => [...options, { options: '', branch_question_id: '' }]);
        }
    };

    const deleteOption = (index) => {
        let optionsList = options;
        let arr = optionsList.splice(index, 1);
        let updatedData = optionsList;
        setOptions(updatedData);
        setFlag(!flag);
    };

    const handleOptions = (e, index) => {
        let arr = options;
        let data = arr[index];
        data['branch_question_id'] = e.target.value;
        arr[index] = data;
        setOptions(arr);
        setFlag(!flag);
    };

    const validateQuestion = () => {
        let result = true;
        if (questionChoiceData.question == '') {
            result = false;
            setQuestionError((questionError) => ({ ...questionError, questionError: 'Enter a valid question' }));
            return false;
        }
        if (questionType == 1 || questionType == 2) {
            if (questionChoiceData.option.length <= 0) {
                setQuestionError((questionError) => ({ ...questionError, optionError: 'Enter a valid option' }));
                result = false;
            }

            if (module && !questionChoiceData.answer && questionType == 1) {
                setQuestionError((questionError) => ({ ...questionError, answerError: 'Select a answer' }));
                result = false;
            }
        }

        return result;
    };

    const choiceQuestion = () => {
        if (isEdit) {
            return (
                <div className="row mt-5">
                    <div className="col-md-12" id={questionIndex} key={'choice'}>
                        <div className="admin-recruit-account-card bg-white p-3">
                            <div className="d-flex justify-content-end mb-4">
                                <button
                                    type="button"
                                    onClick={() => {
                                        moveQuestion('up', questionIndex);
                                    }}
                                    className="btn admin-recruit-btn x regular-text font-14 me-2"
                                >
                                    Move Questions Up
                                    <span>
                                        <img src="/Images/recruit-up-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                                <button
                                    disabled={questionIndex == questionListLength}
                                    onClick={() => {
                                        moveQuestion('down', questionIndex);
                                    }}
                                    type="button buttoncolor"
                                    className="btn admin-recruit-btn regular-text font-14"
                                >
                                    Move Questions Down
                                    <span>
                                        <img src="/Images/recruit-down-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                            </div>
                            <div className="col-md-12 d-flex align-items-center">
                                <span className="me-3 font-14 regular-text">{parseInt(questionIndex) + 1}. </span>
                                <input
                                    type="text"
                                    name="question"
                                    onChange={(e) => {
                                        handleChoiceQuestionData(e);
                                    }}
                                    value={questionChoiceData.question}
                                    placeholder="Enter your question here"
                                    className="form-control hive-form-control"
                                />
                            </div>
                            <div>
                                <span className="text-danger ms-4 mt-2">{questionError.questionError}</span>
                            </div>

                            <div className="mt-3 row align-items-center mb-2 border-bottom">
                                {options.map((option, i) => {
                                    return (
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-check mb-2 d-flex align-items-center">
                                                        <input
                                                            className="form-check-input mt-2 me-2"
                                                            type="radio"
                                                            name="radio"
                                                            defaultValue="option1"
                                                            disabled
                                                        />
                                                        <label className="form-check-label w-100 d-flex">
                                                            <input
                                                                type="text"
                                                                onChange={(e) => {
                                                                    handleChoiceQuestionData(e, i);
                                                                }}
                                                                name="option"
                                                                disabled={option.options === 'Others' ? true : false}
                                                                value={option.options}
                                                                className="form-control w-50 me-3"
                                                                placeholder={`Option ${i + 1}`}
                                                            />
                                                            <a
                                                                onClick={() => {
                                                                    deleteOption(i);
                                                                }}
                                                            >
                                                                <img className=" mt-2" src="/Images/recruit-cross.svg" />
                                                            </a>
                                                        </label>
                                                    </div>
                                                </div>

                                                {/**Adding Dropdown Here */}
                                                {i == 0 && module ? (
                                                    <div className="col-md-4">
                                                        <div className="d-flex  align-items-center list-unstyled">
                                                            <label className="w-25 semibold-text font-14">Answer</label>
                                                            <select
                                                                onChange={(e) => {
                                                                    // handleOptions(e, i);

                                                                    if (e.target.value)
                                                                        setQuestionError((prev) => ({ ...prev, answerError: '' }));

                                                                    setChoiceQuestionData((choice) => ({
                                                                        ...choice,
                                                                        answer: e.target.value,
                                                                    }));
                                                                }}
                                                                value={questionChoiceData.answer}
                                                                className="form-select font-14 semibold-text admin-recruit-selectfont"
                                                                aria-label="Default select example"
                                                            >
                                                                <option value="">Select Answer</option>
                                                                {options.map((option, index) => {
                                                                    return <option value={option.options}>{option.options}</option>;
                                                                })}
                                                            </select>
                                                        </div>
                                                        {questionError?.answerError && (
                                                            <span className="text-danger ms-4 mt-2">{questionError?.answerError}</span>
                                                        )}
                                                    </div>
                                                ) : null}

                                                {showBranch && (
                                                    <div className="col-md-4">
                                                        <div className="d-flex  align-items-center list-unstyled">
                                                            <label className="w-25 semibold-text font-14">Go To</label>
                                                            <select
                                                                onChange={(e) => {
                                                                    handleOptions(e, i);
                                                                }}
                                                                value={option.branch_question_id}
                                                                className="form-select font-14 semibold-text admin-recruit-selectfont"
                                                                aria-label="Default select example"
                                                            >
                                                                <option value=""></option>
                                                                {allQuestionList.map((option, index) => {
                                                                    return <option value={index}>Question {index + 1}</option>;
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                                <div>
                                    <span className="text-danger ms-4 mt-2">{questionError.optionError}</span>
                                </div>
                                <div className="col-md-12 my-3">
                                    <button
                                        type="button"
                                        className="btn  medium-text font-13"
                                        data-bs-toggle="dropdown"
                                        data-bs-display="static"
                                        aria-expanded="false"
                                        onClick={() => {
                                            addOption();
                                            setQuestionError((questionError) => ({ ...questionError, optionError: '' }));
                                        }}
                                    >
                                        <span>
                                            <img src="/Images/recruit-add-option.svg" className="" />
                                        </span>{' '}
                                        Add Option
                                    </button>
                                    <button
                                        type="button"
                                        className="btn medium-text font-13"
                                        data-bs-toggle="dropdown"
                                        data-bs-display="static"
                                        aria-expanded="false"
                                        onClick={() => {
                                            addOption('other');
                                        }}
                                    >
                                        <span>
                                            <img src="/Images/recruit-add-option.svg" className="" />
                                        </span>{' '}
                                        Add Other Option
                                    </button>
                                </div>
                            </div>
                            <div className="col-md-4 d-flex justify-content-between align-items-center mt-2">
                                <a
                                    onClick={() => {
                                        copyQuestionData(questionIndex, questionType);
                                    }}
                                >
                                    <img src="/Images/recruit-copy.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        handleDelete(questionIndex);
                                    }}
                                >
                                    <img className="admin-recruit-bin-size" src="/Images/bin.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        updateData();
                                    }}
                                >
                                    <img className="admin-recruit-tick-size" src="/Images/tick.svg" />
                                </a>
                                <div className="form-check form-switch">
                                    <label className="form-check-label semibold-text font-13">Required</label>
                                    <input
                                        className="form-check-input mt-2"
                                        onChange={(e) => {
                                            setChoiceQuestionData((choiceQuestion) => ({
                                                ...choiceQuestion,
                                                is_required: !choiceQuestion.is_required,
                                            }));
                                        }}
                                        type="checkbox"
                                        checked={questionChoiceData.is_required}
                                    />
                                </div>
                                {!showBranch && (
                                    <a
                                        style={{ visibility: 'hidden' }}
                                        onClick={() => {
                                            setShowBranch(true);
                                        }}
                                        className="branching"
                                    >
                                        <img className="me-2" src="/Images/branching.svg" />
                                        Branching
                                    </a>
                                )}
                                {showBranch && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowBranch(false);
                                            cancelBranching();
                                        }}
                                        className="btn admin-recruit-cancel-btn font-12 semibold-text"
                                    >
                                        Cancel Branching
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    className="  mt-4 bg-white p-3 mb-4"
                    onDoubleClick={() => {
                        setEdit(true);
                    }}
                >
                    <div>
                        <p className="semibold-text font-14">
                            <span>{parseInt(questionIndex) + 1}. </span> {questionChoiceData.question ? questionChoiceData.question : ''}
                            {questionChoiceData.is_required ? <span className="required"> *</span> : null}
                        </p>
                        <div className="d-flex">
                            {options.length > 0
                                ? options.map((option, i) => {
                                    return (
                                        <div className="form-check me-5">
                                            <input
                                                className="form-check-input hive-form-check-input"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id={`flexRadioDefault${questionIndex}${i}`}
                                            />
                                            <label
                                                className="form-check-label hive-form-label"
                                                htmlFor={`flexRadioDefault${questionIndex}${i}`}
                                            >
                                                {option.options}
                                            </label>
                                        </div>
                                    );
                                })
                                : null}
                        </div>
                        {module && (
                            <div className="d-flex mt-4">
                                <label className="form-check-label hive-form-label font-14">Answer:</label>
                                <span className="ms-2"></span>
                                <span className="semibold-text font-14 form-check-label hive-form-label">{questionChoiceData.answer}</span>
                            </div>
                        )}
                    </div>
                </div>
            );
        }
    };

    const textQuestion = () => {
        if (isEdit) {
            return (
                <div className="row mt-5" id={questionIndex}>
                    <div className="col-md-12">
                        <div className="admin-recruit-account-card  bg-white p-3">
                            <div className="d-flex justify-content-end mb-4">
                                <button
                                    onClick={() => {
                                        moveQuestion('up', questionIndex);
                                    }}
                                    type="button"
                                    className="btn admin-recruit-btn x regular-text font-14 me-2"
                                >
                                    Move Questions Up
                                    <span>
                                        <img src="/Images/recruit-up-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                                <button
                                disabled={questionIndex == questionListLength}
                                    onClick={() => {
                                        moveQuestion('down', questionIndex);
                                    }}
                                    type="button buttoncolor"
                                    className="btn admin-recruit-btn regular-text font-14"
                                >
                                    Move Questions Down
                                    <span>
                                        <img src="/Images/recruit-down-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                            </div>
                            <div className="col-md-12 d-flex align-items-center">
                                <span className="me-3 font-14 regular-text">{parseInt(questionIndex) + 1}.</span>
                                <input
                                    type="text"
                                    onChange={(e) => {
                                        handleChoiceQuestionData(e);
                                    }}
                                    value={questionChoiceData.question}
                                    name="question"
                                    placeholder="Enter your question here"
                                    className="form-control hive-form-control"
                                />
                            </div>
                            <div>
                                <span className="text-danger ms-4 mt-2">{questionError.questionError}</span>
                            </div>
                            <div className="col-md-12 mt-4 mb-4 d-flex align-items-center">
                                <input
                                    type="text"
                                    placeholder="Enter your Answer here"
                                    disabled
                                    className="ms-4 form-control hive-form-control"
                                />
                            </div>
                            <div className="row align-items-center mb-2 ms-4 border-bottom"></div>
                            <div className="col-md-3 d-flex justify-content-between ms-4 align-items-center mt-2">
                                <a
                                    onClick={() => {
                                        copyQuestionData(questionIndex, questionType);
                                    }}
                                >
                                    <img src="/Images/recruit-copy.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        updateData();
                                    }}
                                >
                                    <img className="admin-recruit-tick-size" src="/Images/tick.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        handleDelete(questionIndex);
                                    }}
                                >
                                    <img className="admin-recruit-bin-size" src="/Images/bin.svg" />
                                </a>
                                <div className="form-check form-switch">
                                    <label className="form-check-label semibold-text font-13">Required</label>
                                    <input
                                        onChange={(e) => {
                                            setChoiceQuestionData((choiceQuestion) => ({
                                                ...choiceQuestion,
                                                is_required: !choiceQuestion.is_required,
                                            }));
                                        }}
                                        className="form-check-input mt-2"
                                        type="checkbox"
                                        checked={questionChoiceData.is_required}
                                    />
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        onChange={(e) => {
                                            setChoiceQuestionData((choiceQuestion) => ({
                                                ...choiceQuestion,
                                                long_answer: !choiceQuestion.long_answer,
                                            }));
                                        }}
                                        className="form-check-input mt-2"
                                        checked={questionChoiceData.long_answer}
                                        type="checkbox"
                                    />
                                    <label className="form-check-label semibold-text font-13">Long Answer</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    onDoubleClick={() => {
                        setEdit(true);
                    }}
                    className="account-branding-card mt-4 bg-white p-3 mb-3"
                >
                    <div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label hive-form-label font-14 semibold-text ">
                                {parseInt(questionIndex) + 1}. {questionChoiceData.question}
                                {questionChoiceData.is_required ? <span className="required"> *</span> : ''}
                            </label>
                            <textarea
                                type="email"
                                className="form-control hive-form-control recuitad-comment-box"
                                id="exampleFormControlInput1"
                                placeholder=""
                                defaultValue={''}
                                disabled
                                rows={2}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    const checkboxQuestion = () => {
        if (isEdit) {
            return (
                <div className="row mt-5" id={questionIndex}>
                    <div className="col-md-12">
                        <div className="admin-recruit-account-card  bg-white p-3">
                            <div className="d-flex justify-content-end mb-4">
                                <button
                                    type="button"
                                    onClick={() => {
                                        moveQuestion('up', questionIndex);
                                    }}
                                    className="btn admin-recruit-btn x regular-text font-14 me-2"
                                >
                                    Move Questions Up
                                    <span>
                                        <img src="/Images/recruit-up-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                                <button
                                    type="button buttoncolor"
                                    disabled={questionIndex == questionListLength}
                                    onClick={() => {
                                        
                                        moveQuestion('down', questionIndex);
                                    }}
                                    className="btn admin-recruit-btn regular-text font-14"
                                >
                                    Move Questions Down
                                    <span>
                                        <img src="/Images/recruit-down-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                            </div>
                            <div className="col-md-12 mb-4 d-flex align-items-center">
                                <span className="me-3 font-14 regular-text">{parseInt(questionIndex) + 1}. </span>
                                <input
                                    type="text"
                                    name="question"
                                    onChange={(e) => {
                                        handleChoiceQuestionData(e);
                                    }}
                                    value={questionChoiceData.question}
                                    placeholder="Enter your question here"
                                    className="form-control hive-form-control"
                                />
                            </div>
                            <div>
                                <span className="text-danger ms-4 mt-2">{questionError.questionError}</span>
                            </div>
                            <div className="row align-items-center mb-2 border-bottom">
                                {options.map((option, i) => {
                                    return (
                                        <div className="col-md-12 ">
                                            <div className="col-md-6 ">
                                                <div className="form-check  mb-2 d-flex align-items-center">
                                                    <input
                                                        className="form-check-input mt-2 me-2"
                                                        type="checkbox"
                                                        value={option.options}
                                                        name="option"
                                                    />
                                                    <label className="form-check-label w-100 d-flex">
                                                        <input
                                                            type="text"
                                                            value={option.options}
                                                            name="option"
                                                            className="form-control w-50 me-3"
                                                            placeholder={`Option ${i + 1}`}
                                                            onChange={(e) => {
                                                                handleChoiceQuestionData(e, i);
                                                            }}
                                                            disabled={option.options === 'Others' ? true : false}
                                                        />
                                                        <a
                                                            onClick={() => {
                                                                deleteOption(i);
                                                            }}
                                                        >
                                                            <img className=" mt-2" src="/Images/recruit-cross.svg" />
                                                        </a>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div>
                                    <span className="text-danger ms-4 mt-2">{questionError.optionError}</span>
                                </div>
                                <div className="col-md-12 my-3">
                                    <button
                                        type="button"
                                        className="btn  medium-text font-13"
                                        data-bs-toggle="dropdown"
                                        data-bs-display="static"
                                        aria-expanded="false"
                                        onClick={() => {
                                            addOption();
                                            setQuestionError((questionError) => ({ ...questionError, optionError: '' }));
                                        }}
                                    >
                                        <span>
                                            <img src="/Images/recruit-add-option.svg" className="" />
                                        </span>
                                        Add Option
                                    </button>
                                    <button
                                        type="button"
                                        className="btn medium-text font-13"
                                        data-bs-toggle="dropdown"
                                        data-bs-display="static"
                                        aria-expanded="false"
                                        onClick={() => {
                                            addOption('other');
                                        }}
                                    >
                                        <span>
                                            <img src="/Images/recruit-add-option.svg" className="" />
                                        </span>
                                        Add Other Option
                                    </button>
                                </div>
                            </div>
                            <div></div>
                            <div className="col-md-5 d-flex justify-content-between align-items-center mt-2">
                                <a
                                    onClick={() => {
                                        copyQuestionData(questionIndex, questionType);
                                    }}
                                >
                                    <img src="/Images/recruit-copy.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        updateData();
                                    }}
                                >
                                    <img className="admin-recruit-tick-size" src="/Images/tick.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        handleDelete(questionIndex);
                                    }}
                                >
                                    <img className="admin-recruit-bin-size" src="/Images/bin.svg" />
                                </a>
                                <div className="form-check form-switch">
                                    <label className="form-check-label semibold-text font-13">Required</label>
                                    <input
                                        onChange={(e) => {
                                            setChoiceQuestionData((choiceQuestion) => ({
                                                ...choiceQuestion,
                                                is_required: !choiceQuestion.is_required,
                                            }));
                                        }}
                                        className="form-check-input mt-2"
                                        type="checkbox"
                                        checked={questionChoiceData.is_required}
                                    />
                                </div>
                                {!showBranch && (
                                    <a style={{ visibility: 'hidden' }}
                                        onClick={() => {
                                            setShowBranch(true);
                                        }}
                                        className="branching"
                                    >
                                        <img className="me-2" src="/Images/branching.svg" />
                                        Branching
                                    </a>
                                )}
                                {showBranch && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowBranch(false);
                                            cancelBranching();
                                        }}
                                        className="btn admin-recruit-cancel-btn font-12 semibold-text"
                                    >
                                        Cancel Branching
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    onDoubleClick={() => {
                        setEdit(true);
                    }}
                    className="account-branding-card mt-4 bg-white p-3 mb-3"
                >
                    <div>
                        <p className="form-label hive-form-label semibold-text font-14">
                            {parseInt(questionIndex) + 1}. {questionChoiceData.question}
                            {questionChoiceData.is_required ? <span className="required"> *</span> : null}
                        </p>
                        <div className="d-flex align-items-center">
                            {options.map((option, i) => {
                                return (
                                    <div className="form-check">
                                        <input
                                            className="form-check-input hive-form-check-input"
                                            type="checkbox"
                                            defaultValue=""
                                            disabled={option.options === 'options' ? true : false}
                                            id="flexCheckDefault"
                                        />
                                        <label className="form-check-label font-12 regular-text me-5" htmlFor="flexCheckDefault">
                                            {option.options}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        }
    };

    const dateQuestion = () => {
        if (isEdit) {
            return (
                <div className="row mt-5" id={questionIndex}>
                    <div className="col-md-12">
                        <div className="admin-recruit-account-card  bg-white p-3">
                            <div className="d-flex justify-content-end mb-4">
                                <button
                                    type="button"
                                    onClick={() => {
                                        moveQuestion('up', questionIndex);
                                    }}
                                    className="btn admin-recruit-btn x regular-text font-14 me-2"
                                >
                                    Move Questions Up
                                    <span>
                                        <img src="/Images/recruit-up-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                                <button
                                    type="button buttoncolor"
                                    disabled={questionIndex == questionListLength}
                                    onClick={() => {
                                        moveQuestion('down', questionIndex);
                                    }}
                                    className="btn admin-recruit-btn regular-text font-14"
                                >
                                    Move Questions Down
                                    <span>
                                        <img src="/Images/recruit-down-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                            </div>
                            <div className="col-md-12 d-flex align-items-center">
                                <span className="me-3 font-14 regular-text">{parseInt(questionIndex) + 1}.</span>
                                <input
                                    onChange={(e) => {
                                        handleChoiceQuestionData(e);
                                    }}
                                    type="text"
                                    name="question"
                                    value={questionChoiceData.question}
                                    placeholder="Enter your question here"
                                    className="form-control hive-form-control"
                                />
                            </div>
                            <div>
                                <span className="text-danger ms-4 mt-2">{questionError.questionError}</span>
                            </div>
                            <div className="col-md-12 mt-4 mb-4 d-flex align-items-center">
                                <input type="date" disabled className="ms-4 form-control hive-form-control" />
                            </div>
                            <div className="row align-items-center mb-2 ms-4 border-bottom"></div>
                            <div className="col-md-3 d-flex justify-content-between ms-4 align-items-center mt-2">
                                <a
                                    onClick={() => {
                                        copyQuestionData(questionIndex, questionType);
                                    }}
                                >
                                    <img src="/Images/recruit-copy.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        updateData();
                                    }}
                                >
                                    <img className="admin-recruit-tick-size" src="/Images/tick.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        handleDelete(questionIndex);
                                    }}
                                >
                                    <img className="admin-recruit-bin-size" src="/Images/bin.svg" />
                                </a>
                                <div className="form-check form-switch">
                                    <label className="form-check-label semibold-text font-13">Required</label>
                                    <input
                                        onChange={(e) => {
                                            setChoiceQuestionData((choiceQuestion) => ({
                                                ...choiceQuestion,
                                                is_required: !choiceQuestion.is_required,
                                            }));
                                        }}
                                        className="form-check-input mt-2"
                                        type="checkbox"
                                        checked={questionChoiceData.is_required}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    onDoubleClick={() => {
                        setEdit(true);
                    }}
                    className="account-branding-card mt-4 mb-3 bg-white p-3"
                >
                    <div className="col-md-3">
                        <label htmlFor="exampleInputEmail1" className="form-label hive-form-label font-14 semibold-text">
                            {parseInt(questionIndex) + 1}.{questionChoiceData.question}
                            {questionChoiceData.is_required ? <span className="required"> *</span> : null}
                        </label>
                        <input
                            type="date"
                            className="form-control font-12 regular-text w-50"
                            id="exampleInputEmail1"
                            placeholder="Select Domain"
                        />
                    </div>
                </div>
            );
        }
    };

    const fileUploadQuestion = () => {
        if (isEdit) {
            return (
                <div className="row mt-5" id={questionIndex}>
                    <div className="col-md-12">
                        <div className="admin-recruit-account-card  bg-white p-3">
                            <div className="d-flex justify-content-end mb-4">
                                <button
                                    type="button"
                                    onClick={() => {
                                        moveQuestion('up', questionIndex);
                                    }}
                                    className="btn admin-recruit-btn x regular-text font-14 me-2"
                                >
                                    Move Questions Up
                                    <span>
                                        <img src="/Images/recruit-up-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                                <button
                                    type="button buttoncolor"
                                    disabled={questionIndex == questionListLength}
                                    onClick={() => {
                                        moveQuestion('down', questionIndex);
                                    }}
                                    className="btn admin-recruit-btn regular-text font-14"
                                >
                                    Move Questions Down
                                    <span>
                                        <img src="/Images/recruit-down-arrow.svg" className=" ms-2 mb-1" />
                                    </span>
                                </button>
                            </div>
                            <div className="col-md-12 d-flex align-items-center">
                                <span className="me-3 font-14 regular-text">{parseInt(questionIndex) + 1}.</span>
                                <input
                                    type="text"
                                    onChange={(e) => {
                                        handleChoiceQuestionData(e);
                                    }}
                                    name="question"
                                    value={questionChoiceData.question}
                                    placeholder="Enter your question here"
                                    className="form-control hive-form-control"
                                />
                            </div>
                            <div>
                                <span className="text-danger ms-4 mt-2">{questionError.questionError}</span>
                            </div>
                            <div className="col-md-12 mb-4 ms-4 mt-3 d-flex align-items-center">
                                <button className="custom-file-upload-styles btn px-4 py-2 font-13 semibold-text mb-0 me-4">Upload</button>
                            </div>
                            <div className="row align-items-center mb-2 ms-4 border-bottom"></div>
                            <div className="col-md-3 d-flex justify-content-between ms-4 align-items-center mt-2">
                                <a
                                    onClick={() => {
                                        copyQuestionData(questionIndex, questionType);
                                    }}
                                >
                                    <img src="/Images/recruit-copy.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        updateData();
                                    }}
                                >
                                    <img className="admin-recruit-tick-size" src="/Images/tick.svg" />
                                </a>
                                <a
                                    onClick={() => {
                                        handleDelete(questionIndex);
                                    }}
                                >
                                    <img className="admin-recruit-bin-size" src="/Images/bin.svg" />
                                </a>
                                <div className="form-check form-switch">
                                    <label className="form-check-label semibold-text font-13">Required</label>
                                    <input
                                        onChange={(e) => {
                                            setChoiceQuestionData((choiceQuestion) => ({
                                                ...choiceQuestion,
                                                is_required: !choiceQuestion.is_required,
                                            }));
                                        }}
                                        className="form-check-input mt-2"
                                        type="checkbox"
                                        checked={questionChoiceData.is_required}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    onClick={() => {
                        setEdit(true);
                    }}
                    className="account-branding-card mt-4 mb-5 bg-white p-3"
                >
                    <div className="col-md-3">
                        <label htmlFor="Certificate" className="form-label hive-form-label w-100 font-14 semibold-text">
                            {parseInt(questionIndex) + 1}. {questionChoiceData.question}
                            {questionChoiceData.is_required ? <span className="required"> *</span> : null}
                        </label>
                        <button id="Certificate" className="btn bold-text font-12 custom-file-upload-styles">
                            <span className="mx-2">
                                <img src="/Images/recruit-upload-arrow.svg" alt="" />
                            </span>
                            Upload
                        </button>
                    </div>
                </div>
            );
        }
    };

    switch (question) {
        case '1':
            return choiceQuestion();
        case '2':
            return checkboxQuestion();
        case '3':
            return dateQuestion();
        case '4':
            return textQuestion();
        case '5':
            return fileUploadQuestion();
        default:
            return <></>;
    }
}

export default QuestionCard;
